module.exports = __webpack_public_path__ + "img/payment-type-jcb.eea12e59.svg";